import {
  useFetchMeetingsReport,
  useFetchMeetingsReportResults,
  useFetchCancelledMeetingsReport,
  useFetchRescheduledMeetingsReport
} from '../api'
import { REPORT_STATUS } from '../constants'
import { formatDateParams, getLastPeriodDateParams } from '../helpers'

/**
 * @param {string} start - date string
 * @param {string} end - date string
 * @param {string} timezone
 * @param {array} reportKeys - report keys to check for empty data (e.g. totalBookedEvents, totalCancelledEvents, totalRescheduledEvents)
 * @param {boolean} forceNoDataModalClosed - boolean when true forces this function to return false
 *
 * @returns {boolean} returns true when all fetched data was successful every count was 0
 */
export const useCheckForEmptyData = ({ start, end, timezone, reportKeys = [], forceNoDataModalClosed }) => {
  const occurredEventsCurrent = useFetchMeetingsReport({
    status: REPORT_STATUS.OCCURRED,
    ...formatDateParams({ start, end, timezone })
  })
  const occurredEventsPast = useFetchMeetingsReport({
    status: REPORT_STATUS.OCCURRED,
    ...getLastPeriodDateParams({ start, end, timezone }),
  })

  const bookedEventsCurrent = useFetchMeetingsReportResults({
    status: REPORT_STATUS.BOOKED,
    ...formatDateParams({ start, end, timezone })
  })
  const bookedEventsPast = useFetchMeetingsReportResults({
    status: REPORT_STATUS.BOOKED,
    ...getLastPeriodDateParams({ start, end, timezone }),
  })

  const cancelledEventsCurrent = useFetchCancelledMeetingsReport({
    status: REPORT_STATUS.CANCELLED,
    ...formatDateParams({ start, end, timezone })
  })
  const cancelledEventsPast = useFetchCancelledMeetingsReport({
    status: REPORT_STATUS.CANCELLED,
    ...getLastPeriodDateParams({ start, end, timezone }),
  })

  const rescheduledEventsCurrent = useFetchRescheduledMeetingsReport({
    status: REPORT_STATUS.RESCHEDULED,
    ...formatDateParams({ start, end, timezone })
  })
  const rescheduledEventsPast = useFetchRescheduledMeetingsReport({
    status: REPORT_STATUS.RESCHEDULED,
    ...getLastPeriodDateParams({ start, end, timezone }),
  })

  if (forceNoDataModalClosed) return false

  return [
    occurredEventsCurrent,
    occurredEventsPast,
    ...(reportKeys.includes('totalBookedEvents') ? [bookedEventsPast, bookedEventsCurrent] : []),
    ...(reportKeys.includes('totalCancelledEvents') ? [cancelledEventsPast, cancelledEventsCurrent] : []),
    ...(reportKeys.includes('totalRescheduledEvents') ? [rescheduledEventsPast, rescheduledEventsCurrent] : []),
  ].map(({ data = {}, isSuccess, isFetching } = {}) => (
    isFetching ? false : (isSuccess && data.count === 0))
  ).every(Boolean)
}
